export const initialState = {
  step: 1,
  submitting: false,
  siteSelector: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FORM_STEP_GO':
      return { ...state, step: payload, error: null }
    case 'SUBMIT_REQUEST_FORM':
      return { ...state, submitting: true, error: null }
    case 'SUBMIT_REQUEST_FORM_SUCCESS':
      return { ...state, submitting: false, error: null }
    case 'SITE_SELECTOR':
      return { ...state, siteSelector: payload }
    case 'SUBMIT_REQUEST_REJECTED':
      return { ...state, submitting: false, error: payload }
    default:
      return { ...state }
  }
}
